export default function pinterest(list){
var justifiedLayout = require("justified-layout");
    var sizes=[]
    list.forEach((ele) => {
        sizes.push(Math.floor((ele.width / ele.height) * 100) / 100);
      });

      console.log("sizes", sizes);
      var distTest = {
        sizes: sizes,
        className: "various",
        config: {
          containerWidth: document.documentElement.clientWidth,
        },
      };

      var geometry = justifiedLayout(distTest.sizes, distTest.config);
      console.log("geometry", geometry);
     return geometry
}


//////////////////
// WEBPACK FOOTER
// ./src/directives/pinterest.js
// module id = null
// module chunks = 